module.exports = __webpack_public_path__ + "img/Carte-Virtuelle-APAYM-UBA.a1ba97a2.png";